module.exports = __webpack_public_path__ + "img/banner2.af70c896.png";